/**
 * labelCode values sent by the server in SHARING_OPERATION event data.
 * Used for translation keys under notifications.sharing.*
 */
export enum WebSocketDataLabelCodeEnum {
  SharingOperationDownload = 'sharing_operation_download',
  SharingOperationOpen = 'sharing_operation_open',
  SharingOperationEdit = 'sharing_operation_edit',
  SharingOperationDelete = 'sharing_operation_delete',
  SharingOperationRename = 'sharing_operation_rename',
  SharingOperationAdd = 'sharing_operation_add',
  SharingOperationMove = 'sharing_operation_move',
  SharingOperationCopy = 'sharing_operation_copy',
  SharingOperationUnknown = 'sharing_operation_unknown',
}
